import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./auth/AuthProvider";
import { router } from "./router";
import { queryClient } from "./queryClient";
import "./styles/global.css";

// No StrictMode: the player mounts heavy single-init runtimes (CheerpJ inits once
// per document, Ruffle/iframes) imperatively, and StrictMode's double-invoke of
// effects would double-initialize / reload them. Purity is enforced by review.
createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </QueryClientProvider>,
);
